import React from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Paper, Typography, TextField } from '@material-ui/core'

import { pick, isEqual, identity, toNumber } from 'lodash'

const PROP_FIELDS = ['hostname', 'port', 'path']

const generateState = (props) => {
  return {
    original: pick(props, PROP_FIELDS),
    hostname: props.hostname || '',
    port: props.port || '',
    path: props.path || '',
  }
}

const hasEqualPropFields = (obj1, obj2) => {
  return isEqual(pick(obj1, PROP_FIELDS), pick(obj2, PROP_FIELDS))
}

class ServerLocationStep extends React.Component {
  constructor(props) {
    super(props)
    this.state = generateState(props)
  }

  componentDidUpdate(prevProps) {
    if (!hasEqualPropFields(prevProps, this.props)) {
      this.setState(generateState(this.props))
    }
  }

  handleChange(e, modifierFn = identity) {
    const newState = {
      ...this.state,
      [e.target.name]: modifierFn(e.target.value),
    }
    this.setState(newState)
    this.props.onModificationChange(!hasEqualPropFields(newState, newState.original))
  }

  handleSubmit(e) {
    e.preventDefault()
    this.props.onSubmit(this.state.hostname, this.state.port, this.state.path)
  }

  render() {
    return (
      <Paper
        component={Box}
        elevation={0}
        p={2}
        mt={3}
        mb={2}
      >
        <Typography
          variant="h6"
          component="h5"
          gutterBottom
        >
          Step 1: Enter Server location
        </Typography>
        <Typography>This address will be used to connect to your SFTP server.</Typography>

        <form onSubmit={(e) => this.handleSubmit(e)}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            color="primary"
            label="Hostname"
            name="hostname"
            id="sftp-hostname"
            FormHelperTextProps={{ role: 'alert' }}
            required
            helperText="e.g. example.org"
            value={this.state.hostname}
            onChange={(e) => this.handleChange(e)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            color="primary"
            required
            type="number"
            inputProps={{ min: '0' }}
            helperText="e.g. 21"
            FormHelperTextProps={{ role: 'alert' }}
            label="Port"
            name="port"
            id="sftp-port"
            value={this.state.port}
            onChange={(e) => this.handleChange(e, toNumber)}
          />
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            color="primary"
            FormHelperTextProps={{ role: 'alert' }}
            helperText="/destination/folder"
            label="File Path (optional)"
            name="path"
            id="sftp-path"
            value={this.state.path}
            onChange={(e) => this.handleChange(e)}
          />

          <Box mt={2}>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              disabled={this.state.hostname.length < 1 || this.state.port === 0 || this.state.port === ''}
            >
              Save
            </Button>
          </Box>
        </form>
      </Paper>
    )
  }
}

ServerLocationStep.propTypes = {
  hostname: PropTypes.string,
  port: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  path: PropTypes.string,
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onModificationChange: PropTypes.func.isRequired,
}

export default ServerLocationStep
